import {AfterViewInit, Component} from '@angular/core';
import * as fs from 'fs';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements AfterViewInit {

  constructor() {
  }

  ngAfterViewInit(): void {
   // this.modifyJson();
  }

  /*

   private modifyJson() {

     DATA.map((item) => {
       const { street, streetNr, postal, city } = this.splitAddress(item.s_address);
       item.street = street;
       item.streetNr = streetNr;
       item.postal = postal;
       item.city = city;
     });
     console.log('DATA', DATA);

   }
  // Function to split address into street and streetnummer
   splitAddress(address: string) {
     const parts = address.split(',');
     const streetAndnummer = parts[0].trim().match(/^(.*?)(\d+[a-zA-Z]?)$/);
     const cityAndPlz = parts[1].trim().split(/(\d+)/);
     if (streetAndnummer && cityAndPlz) {
       return {
         street: streetAndnummer[1].trim(),
         streetNr: streetAndnummer[2]?.trim(),
         postal: cityAndPlz[1].trim(),
         city: cityAndPlz[2].trim()
       };
     } else {
       // Handle cases where the address format doesn't match
       console.error(`Unable to split address: ${address}`);
       return {
         street: address.trim(),
         streetnummer: '',
         plz: '',
         city: ''
       };
     }
   }
 */

}
